import ScheduleDemoModal from "@/components/ScheduleDemoModal";
import { useAuthStore } from "@/states";
import { useState } from "react";
import { Navigate } from "react-router";
import { HomepageFinalCtaSection, HomepageFooterSection, HomepageSecuritySection, HomepageTestimonialsSection } from "./components/HomepageTrustSections";
import { HomepageCoreFeaturesSection } from "./components/HomepageCoreFeaturesSection";
import { HomepageIntegrationsSection, HomepageProblemSection, HomepageSocialProofSection } from "./components/HomepageMiddleSections";
import { HomepageHeroSection } from "./components/HomepageHero";
import { HomepageNavbarSection } from "./components/HomepageNavbar";

/**
 * LandingPage component for non-authenticated users.
 * @returns Premium animated TripboxCRM landing page
 */
const LandingPage = () => {
  const token = useAuthStore((state) => state.token);
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (token) return <Navigate to="/leads" />;

  return (
    <div
      className="min-h-screen overflow-x-hidden bg-white text-[#131B2A]"
      style={{ fontFamily: "Inter, 'Noto Sans', sans-serif" }}
    >
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-lg focus:bg-[#131B2A] focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-white"
      >
        Skip to content
      </a>

      <HomepageNavbarSection onGetCustomQuote={() => setIsModalOpen(true)} />
      <ScheduleDemoModal open={isModalOpen} onCancel={() => setIsModalOpen(false)} />

      <main id="main-content" className="relative">
        <HomepageHeroSection onRequestQuote={() => setIsModalOpen(true)} />
        <HomepageSocialProofSection />
        <HomepageProblemSection />
        <HomepageCoreFeaturesSection />
        <HomepageIntegrationsSection />
        <HomepageSecuritySection />
        <HomepageTestimonialsSection />
        <HomepageFinalCtaSection onRequestQuote={() => setIsModalOpen(true)} />
      </main>

      <HomepageFooterSection />
    </div>
  );
};

export default LandingPage;
